var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"color-picker"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('chrome-picker',{on:{"input":_vm.colorInput},model:{value:(_vm.hex),callback:function ($$v) {_vm.hex=$$v},expression:"hex"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }